import { connect } from 'react-redux'
import fetchIncomingMails from '../../../../sagas/fetchIncomingMails'
import requestAddIncomingMail from '../../../../sagas/requestAddIncomingMail'
import requestRemoveIncomingMail from '../../../../sagas/requestRemoveIncomingMail'
import incomingEmailsSelector from './incomingEmailsSelector'
import IncomingEmails from './IncomingEmails'

export default connect(
  incomingEmailsSelector,
  {
    fetchIncomingMails,
    requestAddIncomingMail,
    requestRemoveIncomingMail
  }
)(IncomingEmails)
